import React from "react";
import "./AccountScreen.css";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { PaymentElement } from "@stripe/react-stripe-js";
import { useState, useEffect, useCallback } from "react";
import { useActionData, useLocation, useNavigate } from "react-router-dom";
import UserProfileScreen from "./UserProfileScreen";
import { API_IP, STRIPE_KEY } from "../global_variables";
import { axiosReqConfig } from "../functions/axiosRequest";
import NewCardModal from "./AccountComponents/NewCardModal";
import PromptModal from "./ReuseComponent/PromptModal";
// This is where the user ends up after logging in, or clicking "Home" in the navbar.
const stripePromise = loadStripe(STRIPE_KEY);
const UserAccountScreen = ({ setSelectedSection }) => {
  const [cards, setCards] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isAlertVisible, setIsAlertVisible] = useState(false);
  const [isRefresh, setIsRefresh] = useState(false);
  const [isNewCardModalVisible, setIsNewCardModalVisible] = useState(false);
  const [clientSecret, setClientSecret] = useState("");

  const toggleNewCardModal = () => {
    setIsNewCardModalVisible(!isNewCardModalVisible);
  };
  const toggleRefresh = () => setIsRefresh(!isRefresh);
  const toggleAlert = () => setIsAlertVisible(!isAlertVisible);

  const fetchClientSecret = useCallback(async () => {
    try {
      const bearerToken = localStorage.getItem("token");
      const response = await fetch(`${API_IP}/api/create-setup-intent`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${bearerToken}`,
        },
        // You might need to send user data here to associate the customer
      });

      const data = await response.json();

      if (data.clientSecret) {
        setClientSecret(data.clientSecret);
        setCards(data.listCards);
        console.log(data.listCards);
        setLoading(false);
      } else {
        console.error("Failed to get client secret:", data.error);
      }
    } catch (error) {
      console.error("Error fetching client secret:", error);
    }
  }, [isRefresh]);

  useEffect(() => {
    fetchClientSecret();
  }, [fetchClientSecret]);
  if (!clientSecret) {
    return (
      <div className="loading-container">
        <img src={require("../images/loading_icon.gif")} alt="Clock icon" />
      </div>
    ); // Display a loader until clientSecret is available
  }
  const options = {
    appearance: {
      theme: "stripe", // Or your preferred theme
    },
    clientSecret: clientSecret, // Pass the fetched clientSecret
  };
  return (
    <>
      <Elements stripe={stripePromise} options={options}>
        <NewCardModal
          showModal={isNewCardModalVisible}
          handleClose={toggleNewCardModal}
          toggleAlert={toggleAlert}
          toggleRefresh={toggleRefresh}
          clientSecret={clientSecret}
        />
        <PromptModal
          title={"Your card has been successfully saved"}
          type={"alert"}
          showModal={isAlertVisible}
          handleClose={toggleAlert}
        />
      </Elements>
      <div className="screen-container">
        <header className="screen-header">
          <div className="screen-header-text">
            <h1 className="screen-title">Account</h1>
            <p className="screen-subtitle">Manage your account details and payment methods.</p>
          </div>
        </header>

        <div className="account-section">
          <div className="account-header">
          <h2>Account Details</h2>
          <span>
            Last Logged In
            <br />
          </span>
        </div>
        <div className="account-body">
          <div className="account-row">
            <div className="account-input">
              <label>Password</label>
              <input type="password" value="************" readOnly />
            </div>
            <div className="account-input">
              <label>Confirm Password</label>
              <input type="password" value="************" readOnly />
            </div>
          </div>
          {/* <button className="account-edit-button">Edit</button> */}
        </div>
      </div>

      <div className="account-section">
        <div className="account-header">
          <h2>Payment</h2>
          <div>
            <button className="payment-add-button" onClick={toggleNewCardModal}>
              Add New Card
            </button>
          </div>
        </div>
        <div className="payment-body">
          <div className="payment-row">
            <div className="payment-details">
              <div>
                <h4>Your Saved Cards</h4>
                {cards.map((card) => (
                  <div key={card.id} className="card-details">
                    <div className="card-info">
                      <div className="payment-icon-container">
                        <img
                          className="payment-icon"
                          src={require("../images/visa-icon.png")}
                          alt="Clock icon"
                        />
                      </div>
                      <div>
                        <div>
                          <strong>Card Brand:</strong> {card.card.brand}
                        </div>
                        <div>
                          <strong>Number:</strong> **** **** ****{" "}
                          {card.card.last4}
                        </div>
                        <div>
                          <strong>Expiry:</strong> {card.card.exp_month}/
                          {card.card.exp_year}
                        </div>
                      </div>
                    </div>
                    <div className="payment-delete-button-container">
                      <button className="payment-delete-button">
                        <img
                          className="small-loading-icon"
                          src={require("../images/trash-icon.png")}
                          alt="Clock icon"
                        />
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="billing-address">
              <p>
                <strong>Billing Address</strong>
              </p>
              <p>123 Fake St</p>
              <p>Victoria, BC, Canada</p>
            </div>
          </div>
          {/* <button className="payment-edit-button">Edit</button> */}
        </div>
      </div>
    </div>
    </>
  );
};

export default UserAccountScreen;
